import isDefined from "../../../../Core/isDefined";
import * as DTP from "./DateTimePickerStyles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const YearView = _ref => {
  let {
    datesObject,
    onSelectYear
  } = _ref;
  if (!datesObject.dates || datesObject.dates.length <= 12) {
    return null;
  }
  const years = datesObject.index;
  const monthOfYear = Array.apply(null, {
    length: 12
  }).map(Number.call, Number);
  return /*#__PURE__*/_jsxs(DTP.Grid, {
    children: [/*#__PURE__*/_jsx(DTP.GridHeading, {
      children: "Select a year"
    }), /*#__PURE__*/_jsx(DTP.GridBody, {
      children: years.map(y => /*#__PURE__*/_jsxs(DTP.GridRow, {
        onClick: () => onSelectYear(y),
        children: [/*#__PURE__*/_jsx(DTP.GridLabel, {
          children: y
        }), /*#__PURE__*/_jsx(DTP.GridRowInner, {
          marginRight: "11",
          children: monthOfYear.map(m => /*#__PURE__*/_jsx(DTP.GridItem, {
            active: isDefined(datesObject[y][m])
          }, m))
        })]
      }, y))
    })]
  });
};